module.exports = __webpack_public_path__ + "static/img/29-北京市第十八中学附属实验小学.300dbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/29-北京市第十八中学附属实验小学.png
// module id = kSW2
// module chunks = 0